import { Injectable } from '@angular/core';
import { INavData } from '@coreui/angular';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { SolicitudExViewModel } from '../../../_exportacion/solicitudes/datosbasicos/datosbasicosEx.types';
import { SolicitudViewModel } from '../../../_importacion/solicitudes/datosbasicos/datosbasicos.types';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { AuthService } from '../../_infrastructure/classes/services/auth.service';
import { ActionType, AUTH_GRANT_TYPE_ENUM } from '../../_infrastructure/types/common';
import { LoginMenuTypeEnum, navItems } from './_nav';
import { SolicitudAtestFitoViewModel } from '../../../_exportacion/atestaciones/datosbasicos/datosbasicosAtestFito.types';
import { SolicitudCpeViewModel } from '../../../_exportacion/cpe/datosbasicos/cpe.types';
import { NavMenuServiceContenidos } from './navmenu.service.contenidos';
import { NavMenuServiceCampania } from './navmenu.service.campania';
import { Mixin } from 'ts-mixer';
import { NavMenuServiceRecinto } from './navmenu.service.recinto';
import { NavMenuServicePeriodo } from './navmenu.service.periodo';
import { NavMenuServiceSolicitudCam } from './navmenu.service.solicitudcam';
import { NavMenuServiceProgramaVerificacion } from './navmenu.service.programaverificacion';
import { NavMenuServiceUdInspeccion } from './navmenu.service.ud-inspeccion';
import { NavMenuServiceRechazosTraces } from './navmenu.service.rechazostraces';
import { NavMenuServiceTrasladosTraces } from './navmenu.service.trasladostraces';
import { EnumIdsTcTipoSolicitudCam } from 'src/app/components/_campanias/types/enum';

// @reference : multiple inheritance https://www.npmjs.com/package/ts-mixer

@Injectable()
export class NavMenuService extends Mixin(
    NavMenuServiceContenidos,
    NavMenuServiceCampania,
    NavMenuServiceRecinto,
    NavMenuServiceUdInspeccion,
    NavMenuServicePeriodo,
    NavMenuServiceSolicitudCam,
    NavMenuServiceProgramaVerificacion,
    NavMenuServiceRechazosTraces,
    NavMenuServiceTrasladosTraces,
) {
    itemsSubject: BehaviorSubject<INavData[]>;
    items$: Observable<INavData[]>;

    constructor(private authService: AuthService) {
        super();
        this.itemsSubject = new BehaviorSubject<INavData[]>(new Array<INavData>());
        this.items$ = this.getSidebarItems();

        this.authService.logout$.subscribe(() => {
            setTimeout(() => {
                // @author: scalero1 - Le ejecuto dentro de un timeout para que de tiempo a que se ejecute
                // el handler en logout-clave.component
                this.refresh();
            });

            this.resetSolicitudData();
        });
        this.authService.login$.subscribe((grantType: string) => {
            switch (grantType) {
                case AUTH_GRANT_TYPE_ENUM.REFRESH_TOKEN:
                case AUTH_GRANT_TYPE_ENUM.REFRESH_ACLAVE:
                    return;
            }
            this.refresh();
        });
    }

    private _currentSolicitudImportacion = new SolicitudViewModel();
    private _currentSolicitudExportacion = new SolicitudExViewModel();
    private _currentSolicitudAtestacion = new SolicitudAtestFitoViewModel();
    private _currentSolicitudCpe = new SolicitudCpeViewModel();

    public get currentSolicitudImportacion(): SolicitudViewModel {
        if (!this._currentSolicitudImportacion) {
            this._currentSolicitudImportacion = new SolicitudViewModel();
        }
        return this._currentSolicitudImportacion;
    }

    public set currentSolicitudImportacion(value: SolicitudViewModel) {
        this._currentSolicitudImportacion = value;
        this.refresh();
    }

    public get currentSolicitudExportacion(): SolicitudExViewModel {
        if (!this._currentSolicitudExportacion) {
            this._currentSolicitudExportacion = new SolicitudExViewModel();
        }
        return this._currentSolicitudExportacion;
    }

    public set currentSolicitudExportacion(value: SolicitudExViewModel) {
        this._currentSolicitudExportacion = value;
        this.refresh();
    }

    public get currentSolicitudAtestacion(): SolicitudAtestFitoViewModel {
        if (!this._currentSolicitudAtestacion) {
            this._currentSolicitudAtestacion = new SolicitudAtestFitoViewModel();
        }
        return this._currentSolicitudAtestacion;
    }

    public set currentSolicitudAtestacion(value: SolicitudAtestFitoViewModel) {
        this._currentSolicitudAtestacion = value;
        this.refresh();
    }

    public get currentSolicitudCpe(): SolicitudCpeViewModel {
        if (!this._currentSolicitudCpe) {
            this._currentSolicitudCpe = new SolicitudCpeViewModel();
        }
        return this._currentSolicitudCpe;
    }

    public set currentSolicitudCpe(value: SolicitudCpeViewModel) {
        this._currentSolicitudCpe = value;
        this.refresh();
    }

    get isImportSolicitudSelected(): boolean {
        //Si es CLONADA
        //**Esto se hace para que al clonar no se queden datos basicos de la solicitud obligatorios sin rellenar (esto solo puede pasar en IMPOR)
        //**Entonces te obliga a guardar los datos basicos antes de mostrarte el menú lateral
        if (this._currentSolicitudImportacion.TwSolicitudJerarquia != null) {
            return this._currentSolicitudImportacion.Id > 0 && this._currentSolicitudImportacion.TwSolicitudJerarquia.Guardada;
        }
        //Si NO es CLONADA
        else {
            return this._currentSolicitudImportacion.Id > 0;
        }
    }
    get isExportSolicitudSelected(): boolean {
        //Si es CLONADA
        //if (this._currentSolicitudExportacion.TwSolicitudJerarquiaEx != null) {
        //    return this._currentSolicitudExportacion.Id > 0 && this._currentSolicitudExportacion.TwSolicitudJerarquiaEx.Guardada;
        //}
        ////Si NO es CLONADA
        //else {
        return this._currentSolicitudExportacion.Id > 0;
        //}
    }
    get isAtestacionSolicitudSelected(): boolean {
        return this._currentSolicitudAtestacion.Id > 0;
    }

    get isCpeSolicitudSelected(): boolean {
        return this._currentSolicitudCpe.Id > 0;
    }

    /**
     * Esta función evalúa en función del actionCode del item del menú que se está evaluando en cada iteración,
     * los ids ded estado, tipo solicitud y subtipo solicitud, que le corresponden.
     * Se construye el objeto ActionType en función del actionCode pasado por parámetro.
     * Este actionCode será el de un nodo o el de su nodo "padre", cuando sea una opción del submenú de un nodo "padre".
     * @param actionCode string
     * @returns ActionType
     */
    getActionType(actionCode: string): ActionType {
        let action: ActionType = new ActionType();

        switch (actionCode) {
            case EnumCodigosTwTcAcciones.SOLICITUD:
                if (this.isImportSolicitudSelected) {
                    action.IdEstadoSolicitud = this._currentSolicitudImportacion.IdEstadoSolicitud;
                    action.IdTipoSolicitud = this._currentSolicitudImportacion.IdTipoSolicitud;
                    action.IdSubTipoSolicitud = this._currentSolicitudImportacion.IdSubTipoSolicitud;
                }
                break;
            case EnumCodigosTwTcAcciones.SOLICITUD_EXPORTACION:
                if (this.isExportSolicitudSelected) {
                    action.IdEstadoSolicitud = this._currentSolicitudExportacion.IdEstadoSolicitudEx;
                    action.IdTipoSolicitud = this._currentSolicitudExportacion.IdTipoSolicitudEx;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.SOLICITUD_ATESTACION:
                if (this.isAtestacionSolicitudSelected) {
                    action.IdEstadoSolicitud = this._currentSolicitudAtestacion.IdEstado;
                    action.IdTipoSolicitud = this._currentSolicitudAtestacion.IdTipoSolicitudInfCa;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.SOLICITUD_CPE:
                if (this.isCpeSolicitudSelected) {
                    action.IdEstadoSolicitud = this._currentSolicitudCpe.IdEstado;
                    action.IdTipoSolicitud = null;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.MANTENIMIENTOS:
                if (this.isCamSelected) {
                    // Campañas Específicas no requiere el control de acciones a este nivel.
                    action.IdEstadoSolicitud = 0;
                    action.IdTipoSolicitud = null;
                    action.IdSubTipoSolicitud = null;
                }
                if (this.isContenidoSelected) {
                    // El gestor de contenidos no requiere el control de acciones a este nivel.
                    action.IdEstadoSolicitud = 0;
                    action.IdTipoSolicitud = null;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA:
                if (this.isRecintoSelected) {
                    // Recintos no requiere el control de acciones a este nivel.
                    action.IdEstadoSolicitud = 0;
                    action.IdTipoSolicitud = null;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.MENU_UDS_INSPECCION:
                if (this.isUnidadInspeccionSelected) {
                    action.IdEstadoSolicitud = this._currentUdInspeccion?.IdEstadoUi || 0;
                    action.IdTipoSolicitud = this._currentUdInspeccion?.IdTipoSolicitudCam || 0;
                    action.IdSubTipoSolicitud = this._currentUdInspeccion?.PeriodoCertificaKgs ? 1 : 0;
                }
                break;
            case EnumCodigosTwTcAcciones.MENU_DATOS_CA_Y_ENTIDADES:
                if (this.isPeriodoSelected) {
                    // Periodos no requiere el control de acciones a este nivel.
                    action.IdEstadoSolicitud = 0;
                    action.IdTipoSolicitud = null;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.MENU_SOL_CAM:
                if (this.isSolicitudCamSelected) {
                    // Campañas no requiere el control de acciones a este nivel.
                    action.IdEstadoSolicitud = this._currentSolicitudCam?.IdEstadoSolicitudCam || 0;
                    action.IdTipoSolicitud = this._currentSolicitudCam?.IdTipoSolicitudCam || 0;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.PROGRAMAS_VERIFICACION:
                if (this.isProgramaVerificacionSelected) {
                    // Programa Verificacion no requiere el control de acciones a este nivel.
                    action.IdEstadoSolicitud = this._currentProgramaVerificacion?.IdEstadoPv || 0;
                    action.IdTipoSolicitud = null;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES:
                if (this.isRechazoTracesSelected) {
                    // El buscador de rechazos de TRACES no requiere el control de acciones a este nivel.
                    action.IdEstadoSolicitud = 0;
                    action.IdTipoSolicitud = null;
                    action.IdSubTipoSolicitud = null;
                }
                break;
            case EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES:
                if (this.isTrasladoTracesSelected) {
                    // El buscador de traslados de TRACES no requiere el control de acciones a este nivel.
                    action.IdEstadoSolicitud = 0;
                    action.IdTipoSolicitud = null;
                    action.IdSubTipoSolicitud = null;
                }
                break;
        }

        return action;
    }

    refresh() {
        this.itemsSubject.next(this.getSidebarNav());
    }

    resetSolicitudData() {
        super.resetContenidoData();
        super.resetCampaniaData();
        super.resetRecintoData();
        super.resetPeriodoData();
        super.resetSolicitudCamData();
        super.resetUdInspeccionData();
        super.resetRechazoTracesData();
        super.resetTrasladoTracesData();
        this._currentSolicitudImportacion = new SolicitudViewModel();
        this._currentSolicitudExportacion = new SolicitudExViewModel();
        this._currentSolicitudAtestacion = new SolicitudAtestFitoViewModel();
        this._currentSolicitudCpe = new SolicitudCpeViewModel();
    }

    resetSolicitudExData() {
        this._currentSolicitudExportacion = new SolicitudExViewModel();
    }

    private getSidebarNav(): Array<INavData> {
        let items: INavData[] = new Array<INavData>();

        navItems.forEach(navItem => {
            //...do some logic here

            if (this.isVisible(navItem)) {
                let item: INavData = new Object();

                item.icon = navItem.icon;
                item.name = navItem.name;
                item.title = navItem.title;
                item.url = this.getRouterLink(navItem);

                if (navItem.children) {
                    item.children = new Array<INavData>();

                    navItem.children.forEach(navChild => {
                        if (this.isVisible(navChild, navItem)) {
                            let child: INavData = new Object();

                            child.icon = navChild.icon;
                            child.name = this.getMenuName(navChild);
                            child.title = navChild.title;
                            child.url = this.getRouterLink(navChild);
                            item?.children?.push(child);
                        }
                    });
                }

                items.push(item);
            }
        });

        return items;
    }

    private getMenuName(navChild: any): string {
        if (navChild.icon === 'icon-recintos_pia' && this._currentSolicitudCam) {
            return this.getMenuNameForCampanias(navChild);
        } else {
            return navChild.name;
        }
    }

    /**
     * Este método devuelve el texto que aparece en la entrada de submenú de Campañas/Recintos "PIADEd".
     * El texto que devuelve depende el tipo de solicitud de la solicitud.
     * @author scalero1: Esto podría hacerse también con permisos sobre las tablas acciones y acciones-campaña. Pero éste modo es más sencillo.
     * @param navChild any
     * @returns string
     */
    private getMenuNameForCampanias(navChild: any): string {
        switch (this._currentSolicitudCam?.IdTipoSolicitudCam) {
            case EnumIdsTcTipoSolicitudCam.ID_PARCELA:
                navChild.name = 'Parcelas';
                break;
            case EnumIdsTcTipoSolicitudCam.ID_INVERNADERO:
                navChild.name = 'Invernaderos';
                break;
            case EnumIdsTcTipoSolicitudCam.ID_CONFECCION:
                navChild.name = 'Almacenes';
                break;
            case EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION:
                navChild.name = 'Emp. Deshidratadoras';
                break;
            default:
                break;
        }
        return navChild.name;
    }

    private getSidebarItems(): Observable<INavData[]> {
        of(this.getSidebarNav()).subscribe({
            error: x => this.itemsSubject.error(x),
            next: x => this.itemsSubject.next(x),
            // complete: () => this.itemsSubject.complete(),
        });

        return this.itemsSubject.asObservable();
    }

    private isVisible(navItem: any, navItemParent?: any): boolean {
        if (navItem.loginMenuType == LoginMenuTypeEnum.Always) {
            return true;
        }

        if (navItem.loginMenuType == LoginMenuTypeEnum.LoggedOut && !this.authService.isLoggedIn()) {
            return true;
        }

        return this.isVisibleLoggedIn(navItem, navItemParent);
    }

    /**
     * Esta función evalúa si un item del menú, es visible o no.
     * Para ello tiene en cuenta:
     * - si el usuario está logado o no
     * - el actionType que contiene el id de la "solicitud", su estado y el subtipo.
     * - Si el nodo es un nodo "padre", se evaluará su actionCode,
     * - Si el nodo es un nodo "hijo", se evaluará el actionCode del nodo "padre".
     * Cada actionCode tendrá una visibilidad en función de los permisos que tenga el usuario para ésa acción.
     * @param navItem INavDataCexveg El item del menú que se está evaluando en cada iteración.
     * @param navItemParent INavDataCexveg Este parámetro será null, cuando sea un nodo "padre".
     * @returns boolean
     */
    private isVisibleLoggedIn(navItem: any, navItemParent?: any): boolean {
        let output = this.authService.isLoggedIn() && navItem.loginMenuType !== LoginMenuTypeEnum.LoggedOut;

        if (this.hasAction(navItem)) {
            const user = this.authService.getLoggedInUser();

            if (user) {
                if (navItem.actionCode == EnumCodigosTwTcAcciones.MENU_PREVIA) {
                    output = output && this._currentSolicitudImportacion.EsPrevia;
                } else if (navItem.actionCode == EnumCodigosTwTcAcciones.MENU_PREVIA_EXPORTACION) {
                    output = output && this._currentSolicitudExportacion.EsPrevia;
                } else if (navItem.actionCode == EnumCodigosTwTcAcciones.MENU_ALEGACIONES) {
                    output = output && this._currentSolicitudExportacion.TieneAlegacion;
                } else {
                    let actionCode = navItem.actionCode;
                    if (navItemParent) {
                        actionCode = navItemParent.actionCode;
                    }

                    const actionType = this.getActionType(actionCode);
                    output =
                        output &&
                        user.getAction(navItem.actionCode, actionType.IdEstadoSolicitud, actionType.IdTipoSolicitud!, actionType.IdSubTipoSolicitud!).Visible;
                }
            }
        }

        if (navItem.actionCode === EnumCodigosTwTcAcciones.SOLICITUD && navItem.visibleAfterSearching && navItem.children.some((s: any) => s.isImportDetail)) {
            output = output && this.isImportSolicitudSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.SOLICITUD_EXPORTACION &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isExportDetail)
        ) {
            output = output && this.isExportSolicitudSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.SOLICITUD_ATESTACION &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isAtestacionDetail)
        ) {
            output = output && this.isAtestacionSolicitudSelected;
        }

        if (navItem.actionCode === EnumCodigosTwTcAcciones.SOLICITUD_CPE && navItem.visibleAfterSearching && navItem.children.some((s: any) => s.isCpeDetail)) {
            output = output && this.isCpeSolicitudSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.MANTENIMIENTOS &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isCamDetail)
        ) {
            output = output && this.isCamSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.MANTENIMIENTOS &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isContenidoDetail)
        ) {
            output = output && this.isContenidoSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.MENU_RECINTO_CAMPANIA &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isRecintoDetail)
        ) {
            output = output && this.isRecintoSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.MENU_UDS_INSPECCION &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isUdInspeccionDetail)
        ) {
            output = output && this.isUnidadInspeccionSelected;
        }

        if (
            (navItem.actionCode === EnumCodigosTwTcAcciones.MENU_DATOS_CA_Y_ENTIDADES || navItem.actionCode === EnumCodigosTwTcAcciones.MANTENIMIENTOS) &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isPeriodoDetail)
        ) {
            output = output && this.isPeriodoSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.MENU_SOL_CAM &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isSolCamDetail)
        ) {
            output = output && this.isSolicitudCamSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.PROGRAMAS_VERIFICACION &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isProgramaVerificacionDetail)
        ) {
            output = output && this.isProgramaVerificacionSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.MENU_RECHAZOS_TRACES &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isRechazoTracesDetail)
        ) {
            output = output && this.isRechazoTracesSelected;
        }

        if (
            navItem.actionCode === EnumCodigosTwTcAcciones.MENU_TRASLADOS_TRACES &&
            navItem.visibleAfterSearching &&
            navItem.children.some((s: any) => s.isTrasladoTracesDetail)
        ) {
            output = output && this.isTrasladoTracesSelected;
        }

        return output;
    }

    private getRouterLink(navItem: any): string {
        if (navItem.isImportDetail) {
            return navItem.url + '/' + this._currentSolicitudImportacion.Id;
        }
        if (navItem.isExportDetail) {
            return navItem.url + '/' + this._currentSolicitudExportacion.Id;
        }
        if (navItem.isAtestacionDetail) {
            return navItem.url + '/' + this._currentSolicitudAtestacion.Id;
        }
        if (navItem.isSolCamDetail) {
            return navItem.url + '/' + this._currentSolicitudCam?.Id;
        }
        if (navItem.isCpeDetail) {
            return navItem.url + '/' + this._currentSolicitudCpe.Id;
        }
        if (navItem.isContenidoDetail) {
            return navItem.url + '/' + this._currentContenido?.Id;
        }
        if (navItem.isRecintoDetail) {
            return navItem.url + '/' + this._currentRecinto?.Id;
        }
        if (navItem.isUdInspeccionDetail) {
            return navItem.url + '/' + this._currentUdInspeccion?.IdUi;
        }
        if (navItem.isPeriodoDetail) {
            return navItem.url + '/' + this._currentPeriodo?.Id;
        }
        if (navItem.isProgramaVerificacionDetail) {
            return navItem.url + '/' + this._currentProgramaVerificacion?.Id;
        }
        if (navItem.isCamDetail) {
            return navItem.url + '/' + this._currentCampania?.Id;
        }
        if (navItem.isRechazoTracesDetail) {
            return navItem.url + '/' + this.currentRechazoTraces?.CHEDPP;
        }
        if (navItem.isTrasladoTracesDetail) {
            return navItem.url + '/' + this.currentTrasladoTraces?.CHEDPP;
        } else if (navItem.isUserDetail) {
            return navItem.url + '/' + this.authService.getLoggedInUser()!.Id.toString();
        } else {
            return navItem.url;
        }
    }

    /**
     * Esta función comprueba si el item pasado por parámetro tiene una propiedad "actionCode" o no.
     * @param navItem INavDataCexveg
     * @returns boolean
     */
    private hasAction(navItem: Object): boolean {
        return Object.prototype.hasOwnProperty.call(navItem, 'actionCode');
    }
}
